import type { IconSvgObject } from './types';

const LottiefilesIcon: IconSvgObject = [
  ["path", { d: "M19.5 2.5H4.5C3.39543 2.5 2.5 3.39543 2.5 4.5V19.5C2.5 20.6046 3.39543 21.5 4.5 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5V4.5C21.5 3.39543 20.6046 2.5 19.5 2.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 7.5H16.8536C15.4009 7.5 14.0625 8.28757 13.357 9.55743L10.643 14.4426C9.93754 15.7124 8.59906 16.5 7.14639 16.5H6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default LottiefilesIcon;
